import React from 'react';
import {useState} from 'react';
import people from './data';
import './style.css';


const Birthday = (props) => {
    const {name, age, img} = props.info;
    return(
        <React.Fragment >
            <div className="img-container" style={{backgroundImage: "url(https://quyumkehinde.com/" + img + ")", backgroundSize: "cover"}}>
            </div>
            <div className="birthday-info">
                <h2>{name}</h2>
                <span>{age + " years"}</span>
            </div>
        </React.Fragment>
        
    );
}

const Functionality = () => {
    const removeItem = (index) => {
        const newBirthday = birthday.filter((day) => {
            return (day !== birthday[index])
        
        });
        setBirthday(newBirthday);
    }
    const [birthday, setBirthday] = useState(people);
    return(
        <React.Fragment>
        <main className="main">
            <h1>{birthday.length + " Birthdays Today"}</h1>
            {birthday.map((person, index) =>{
                return(
                    <div className="birthday" key={index + 1}>
                        <Birthday key={index} info={{...person, index}} />
                        <button className="delete-button" onClick={() => removeItem(index)}>
                            <i className="delete-icon fa fa-trash" aria-hidden="true"></i>
                        </button>
                    </div>
                )
            })}
            <button className="clear-all" onClick={()=> setBirthday([])}>Clear All</button>
            
        </main>
        
        </React.Fragment>
    )

    
}

export default Functionality;